import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import { TrifoodLogo } from "../../commons/resources";
import { REFRESH_TOKEN_KEY, TOKEN_KEY } from "../../commons/constants";

export default function WelcomePage() {
  const navigate = useNavigate();
  
  const returnHomePage = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    navigate("/login");
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "20px",
          width: 500,
          height: 300,
          margin: "auto",
          color: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginBottom: "20px",
            width: "230px",
            height: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TrifoodLogo />
        </div>
        <h1 style={{ fontSize: "2rem" }}>Welcome to TriFood!</h1>
        <p style={{ fontSize: "1rem" }}>We are excited to have you here. Enjoy your experience.</p>
      </div>
      <PrimaryButton style={{ width: 200 }} onClick={returnHomePage}>
        Back to Home
      </PrimaryButton>
    </div>
  );
}
